import { InputConfig } from "@cpj-ai/panel-npm-package";

export const inputConfig: InputConfig[] = [
  {
    name: "email",
    previewSize: {
      sm: 12,
    },
    inputProps: {
      type: "text",
      label: "Your email :",
      placeholder: "Enter your company email",
    },
    rules: {
      required: "This field is required",
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: "Invalid email address",
      },
    },
  },

  {
    name: "phone",
    previewSize: {
      sm: 12,
    },
    inputProps: {
      type: "phone",
      label: "Organization phone number:",
      placeholder: "Enter Contact Number",
    },
    rules: {
      required: "This field is required",
    },
  },
];
